import { EventType } from '@/analytics/types';

import SDBFCMHeroTemplate2025 from './HolidayHeroTemplate25';

const GiftingHero = () => {
  return (
    <SDBFCMHeroTemplate2025
      titleMsgKey="gifting_hero_title_2025"
      subcopyMsgKey="gifting_hero_description_2025"
      buttonProps={{
        href: '/store',
        ctaLabel: 'header_shop_now',
        onClick: () => {
          void window.ouraAnalytics.track(EventType.CTAClicked, {
            cta: 'shop now',
            action: 'go to store',
            location: 'home hero',
            path: '/store',
          });
        },
      }}
    />
  );
};
export default GiftingHero;
